import React, { useState } from 'react';
import { FaCrown, FaUser, FaMoon, FaSun } from 'react-icons/fa';
import { Link } from 'react-router-dom';

const BottomBar = ({ user, handleLogout, darkMode, toggleDarkMode }) => {
  const [showAdminLinks, setShowAdminLinks] = useState(false);

  const toggleAdminPopup = () => {
    setShowAdminLinks(!showAdminLinks);
  };

  return (
    <footer className="bg-white dark:bg-gray-900 shadow-md fixed bottom-0 w-full z-50">
      <div className="max-w-7xl mx-auto flex justify-between items-center p-4">
        <div className="flex items-center space-x-4">
          {user && (
            <div className="relative flex items-center space-x-2">
              {user.roles.includes('admin') ? (
                <>
                  <FaCrown className="text-yellow-500" />
                  <button
                    onClick={toggleAdminPopup}
                    className="text-sm text-blue-600 underline"
                  >
                    {user.name}
                  </button>
                  {showAdminLinks && (
                    <div className="absolute bottom-8 left-0 bg-white dark:bg-gray-800 p-4 rounded-lg shadow-md">
                      <h3 className="font-bold mb-2">Admin</h3>
                      <ul className="space-y-2">
                        <li><Link to="/users" className="text-blue-600 hover:underline" onClick={toggleAdminPopup}>Users</Link></li>
                        <li><Link to="/admin/blog" className="text-blue-600 hover:underline" onClick={toggleAdminPopup}>Blog</Link></li>
                        <li><Link to="/meshtastic/send" className="text-blue-600 hover:underline" onClick={toggleAdminPopup}>Send Message</Link></li>
                      </ul>
                    </div>
                  )}
                </>
              ) : (
                <>
                  <FaUser />
                  <span>{user.name}</span>
                </>
              )}
            </div>
          )}
        </div>
        <div className="flex items-center space-x-4">
          {user ? (
            <button
              onClick={handleLogout}
              className="bg-red-500 text-white p-2 rounded"
            >
              Logout
            </button>
          ) : (
            <a href="/login" className="bg-blue-500 text-white p-2 rounded">
              Login
            </a>
          )}
          <button onClick={toggleDarkMode} className="text-xl">
            {darkMode ? <FaSun className="text-yellow-500" /> : <FaMoon />}
          </button>
        </div>
      </div>
    </footer>
  );
};

export default BottomBar;
